import React from 'react';
import { FemEntityLanding } from './pages/FemEntityLanding';
import { InvestorsPage } from './pages/InvestorsPage';
import { PractitionersPage } from './pages/PractitionersPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { AppLaunchPage } from './pages/AppLaunchPage';
export function App() {
  const path = window.location.pathname;
  if (path === '/investors') {
    return <InvestorsPage data-id="element-0" data-mp="2rkdy0w5h7fot" />;
  }
  if (path === '/practitioners') {
    return <PractitionersPage data-id="element-1" data-mp="2rikn34nty9b0" />;
  }
  if (path === '/privacy-policy') {
    return <PrivacyPolicyPage data-id="element-2" data-mp="2mndryl8mmcxp" />;
  }
  if (path === '/get-the-app') {
    return <AppLaunchPage data-id="element-3" data-mp="31ayqs2ygxpzt" />;
  }
  return <FemEntityLanding data-id="element-4" data-mp="31c9uk2rwyxqx" />;
}